import React from "react";
import { Box, Container, Typography, useTheme } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import Title from "../../components/typography/Title";

const ExternalSubmit = () => {

    const theme = useTheme();

    return (
        <PageContent showImageHeader={false} paddingTop={6} footerWidth={null}>
            <Container maxWidth="sm">
                <Box sx={{
                    boxShadow: theme.shadows[3],
                    borderRadius: theme.spacing(3),
                    padding: theme.spacing(4),
                }}>
                    <Title label="Inscrição Submetida" variant="h2" fullWidth={true} />
                    <Typography sx={{ marginTop: theme.spacing(2)}}>
                        A inscrição foi submetida com sucesso.
                        Obrigado por continuares com a ADCB para mais uma época.
                        A tua inscrição encontra-se agora a ser validada.
                    </Typography>
                </Box>
            </Container>
        </PageContent>
    );
};

export default ExternalSubmit;
